<template>
  <div class="my-24">
    <p class="line-on-side m-0 text-neutral-60 text-center text-b-xs">
      <span>{{ props.text }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  text: string,
}>(), {
  text: '',
});

</script>

<script lang="ts">
export default {
  name: 'SeChatBoxDividerInfo',
};
</script>
